import { AbstractControl, ValidationErrors } from "@angular/forms";

/**
 * checks if the string contains a-z 0-9 or spaces or + and -
 */
export const alphaNumeric = (control: AbstractControl): ValidationErrors | null => {
  return new RegExp("^[a-zA-Z0-9 +-]+$", "g").test(control.value) ? null : { invalidAlphaNumeric: true };
};
